<template>
  <div class="panel">
    <!-- @slot The panel content -->
    <slot>panel</slot>
  </div>
</template>

<style lang="scss" scoped>
.panel {
  position: relative;
  overflow: hidden;
  width: 400px;
  max-width: 500px;
  min-height: 300px;
  box-shadow: 0 4px 18px -6px rgba(0, 0, 0, 0.26);
  background-color: white;
}
</style>
